type Method = 'GET' | 'POST';
type Destination = { readonly plain: string; readonly secure?: string };

/** The Office transport facade's finite set of shared API operations. */
const routes: Readonly<Record<string, Destination>> = {
    'GET /copilots': { plain: '/api/copilot/copilots', secure: '/api/secure/copilot/copilots' },
    'POST /sellcode/apply': { plain: '/api/copilot/sellcode/apply', secure: '/api/secure/copilot/sellcode/apply' },
    'POST /subscription/user-subscription': { plain: '/api/subscription/user-subscription', secure: '/api/secure/subscription/user-subscription' },
    'POST /msg/send': { plain: '/api/r2-chat/msg/send', secure: '/api/secure/r2-chat/msg/send' },
    'POST /msgs/get': { plain: '/api/r2-chat/msgs/get', secure: '/api/secure/r2-chat/msgs/get' },
    'POST /thread/create-if-not-exists': { plain: '/api/r2-chat/thread/create-if-not-exists', secure: '/api/secure/r2-chat/thread/create-if-not-exists' },
    'POST /thread/id/assign': { plain: '/api/r2-chat/thread/id/assign', secure: '/api/secure/r2-chat/thread/id/assign' },
    'POST /thread/delete': { plain: '/api/r2-chat/thread/delete', secure: '/api/secure/r2-chat/thread/delete' },
    'POST /thread/msg/delete': { plain: '/api/r2-chat/thread/msg/delete', secure: '/api/secure/r2-chat/thread/msg/delete' },
    'POST /group-chat/user/msg/add': { plain: '/api/group-chat/user/msg/add', secure: '/api/secure/group-chat/user/msg/add' },
    'POST /group-chat/user/msgs/get': { plain: '/api/group-chat/user/msgs/get', secure: '/api/secure/group-chat/user/msgs/get' },
    'POST /group-chat/user/msg/get': { plain: '/api/group-chat/user/msg/get', secure: '/api/secure/group-chat/user/msg/get' },
    'POST /group-chat/users/get': { plain: '/api/group-chat/users/get', secure: '/api/secure/group-chat/users/get' },
    'POST /group-chat/user/msg/delete': { plain: '/api/group-chat/user/msg/delete', secure: '/api/secure/group-chat/user/msg/delete' },
    'POST /group-chat/user/msgs/delete/all': { plain: '/api/group-chat/user/msgs/delete/all', secure: '/api/secure/group-chat/user/msgs/delete/all' },
    'POST /audio/transcribe': { plain: '/api/audio/transcribe', secure: '/api/secure/audio/transcribe' },
    'GET /file/limits/get': { plain: '/api/file/limits/get', secure: '/api/secure/file/limits/get' },
    'POST /file/upload/start': { plain: '/api/file/upload/start', secure: '/api/secure/file/upload/start' },
    'POST /file/upload/check': { plain: '/api/file/upload/check', secure: '/api/secure/file/upload/check' },
    'POST /file/download/start': { plain: '/api/file/download/start', secure: '/api/secure/file/download/start' },
    'POST /file/download/check': { plain: '/api/file/download/check', secure: '/api/secure/file/download/check' },
    'POST /skills/unwrap': { plain: '/api/v2/r2-chat/skills/unwrap' },
    'POST /v3/skills/unwrap': { plain: '/api/v3/r2-chat/skills/unwrap' },
    'POST /contacts/support': { plain: '/api/contacts/support' },
    'POST /contacts/report-issue': { plain: '/api/contacts/report-issue' },
    'GET /models': { plain: '/api/r2-chat/models' },
    'GET /user/settings': { plain: '/api/r2-chat/user/settings' },
    'GET /skills': { plain: '/api/v2/r2-chat/skills' },
    'GET /skill-tags': { plain: '/api/r2-chat/skill-tags' },
    'GET /instructions': { plain: '/api/v2/r2-chat/instructions' },
    'GET /locales': { plain: '/api/r2-chat/locales' },
    'GET /message-history-presets': { plain: '/api/r2-chat/message-history-presets' },
    'GET /answer-lengths': { plain: '/api/r2-chat/answer-lengths' },
    'GET /chat-defaults': { plain: '/api/r2-chat/chat-defaults' },
};

export function officeApiRoute(method: Method, path: string, secure: boolean): string
{
    const destination = routes[`${method} ${path}`];
    if (!destination || (secure && !destination.secure))
        throw new Error(`Unsupported Office API operation: ${method} ${path}`);
    return secure ? destination.secure! : destination.plain;
}
